import React from 'react';
import { isExternal, isCMG, getBalance } from '@ally/transfer-account-utils';
import { asCurrency, maskAccountNumber } from '@ally/aos-utils';
var AccountLabel = function (_a) {
    var account = _a.account, _b = _a.isInvestTransfer, isInvestTransfer = _b === void 0 ? false : _b;
    var nickname = account.nickname, accountNumberPvtEncrypt = account.accountNumberPvtEncrypt;
    var maskedAccountNumber = maskAccountNumber(accountNumberPvtEncrypt);
    var nicknameAndNumber = "".concat(nickname || '', " ").concat(maskedAccountNumber).trim();
    if (isExternal(account)) {
        var bankName = account.domainDetails.bankName;
        return React.createElement(React.Fragment, null, "".concat(bankName, " ").concat(maskedAccountNumber, " ").concat(nickname || '').trim());
    }
    if (isInvestTransfer) {
        return React.createElement(React.Fragment, null, nicknameAndNumber);
    }
    var balance = asCurrency(getBalance(account));
    if (isCMG(account)) {
        return (React.createElement(React.Fragment, null,
            nicknameAndNumber,
            React.createElement("br", null), "(HELOC Available Balance: ".concat(balance, ")")));
    }
    return React.createElement(React.Fragment, null, "".concat(nicknameAndNumber, " (").concat(balance, ")"));
};
export default AccountLabel;
//# sourceMappingURL=AccountLabel.js.map